import TabSelect from 'components/Tabs';
import React, { useState } from 'react';
import ManualTab from './Tabs/ManualTab';
import Box from '@mui/material/Box';
import styles from './AdminContentPage.module.scss';

const TABS = [
  {
    name: 'Main',
    child: [
      {
        name: 'Main',
      },
      {
        name: 'About',
      },
      {
        name: 'How does work ',
      },
      {
        name: 'SDGs',
      },
    ],
  },
  {
    name: 'Roles',
    child: [
      {
        name: 'Expert role',
      },
      {
        name: 'Investor role',
      },
      {
        name: 'Business role',
      },
      {
        name: 'Individual',
      },
    ],
  },
  {
    name: 'Legal',
    child: [
      {
        name: 'Privacy policy',
      },
      {
        name: 'Terms of service',
      },
      {
        name: 'Honor guidelines',
      },
      {
        name: 'Validator agreement',
      },
    ],
  },
  {
    name: 'Calculators',
    child: [
      {
        name: 'About',
      },
      {
        name: 'Offset credits',
      },
      {
        name: 'Global',
      },
      {
        name: 'Local',
      },
      {
        name: 'Carbon',
      },
      {
        name: 'South Pole',
      },
    ],
  },
  {
    name: 'Manual',
    child: [
      {
        name: 'Presentations',
      },
      {
        name: 'Tutorials',
      },
    ],
  },
];

const AdminContentPage = () => {
  const [activeTab, setActiveTab] = useState(4);
  const [activeChildTab, setActiveChildTab] = useState(1);
  return (
    <Box className={styles.pageContent}>
      <TabSelect
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        setActiveChildTab={setActiveChildTab}
        activeChildTab={activeChildTab}
        options={TABS}
      />
      {activeTab === 4 && <ManualTab activeChildTab={activeChildTab} />}
    </Box>
  );
};
export default AdminContentPage;
